import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
  standalone: true,
})
export class IncludesPipe<T> implements PipeTransform {
  transform(value: T[], search: T | T[]): boolean {
    if (!Array.isArray(value) || !value.length || search == null) return false;

    const searchArray: T[] = Array.isArray(search) ? search : [search];

    return searchArray.some(term =>
      value.some(item => this.compareValues(item, term))
    );
  }
  private compareValues(a: T, b: T): boolean {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.toLowerCase() === b.toLowerCase();
    }
    return a === b;
  }
}
